const config = {
  imageUrl: process.env.GATSBY_IMAGE_HOST,
}

export default config
